<div class="qvs-validate-payment-order-request-proceed">
  <qvs-status-screen
    class="qvs-validate-payment-order-request-proceed"
    *ngIf="ordersPaymentRequest as request"
    [title]="'shared.status-screen.PROCESSING' | translate"
    [type]="statusScreenType.PENDING"
    [closeButtonText]="'payments.CANCEL' | translate"
    (closed)="close()"
  >
    <ng-container *ngIf="request.payment as payment">
      <h2 class="qvs-validate-payment-order-request-proceed__title">
        {{ 'payments.PAYMENT_PROCEED' | translate }}
      </h2>
      <div class="qvs-validate-payment-order-request-proceed__description">
        <p class="qvs-validate-payment-order-request-proceed__description__beneficiary">
          {{ payment.beneficiaryName }}
        </p>
        <p
          class="qvs-validate-payment-order-request-proceed__description__amount"
          [innerHTML]="
            { value: payment.amount, currency: payment.currency?.currency }
              | amount: true : undefined : undefined : undefined : payment.account?.currencyId
          "
        ></p>
        <p *ngIf="payment.executionDate" class="qvs-validate-payment-order-request-proceed__description__date">
          {{ payment.executionDate | localDate }}
        </p>
      </div>
    </ng-container>
    <ng-container *ngIf="request.transfer as transfer">
      <h2 class="qvs-validate-payment-order-request-proceed__title">
        {{ 'payments.TRANSFER_PROCEED' | translate }}
      </h2>
      <div class="qvs-validate-payment-order-request-proceed__description">
        <p
          class="qvs-validate-payment-order-request-proceed__description__amount"
          [innerHTML]="
            { value: transfer.amount, currency: transfer.debitAccount.currencyId }
              | amount: true : undefined : undefined : undefined : transfer.creditAccount.currencyId
          "
        ></p>
        <p class="qvs-validate-payment-order-request-proceed__description__portfolio">
          <span>{{ transfer.debitAccount.portfolio.name }}</span>
          <span>
            {{ transfer.debitAccount.currencyId }} {{ transfer.debitAccount.portfolio.portfolioNumber | accountIdShorten }}
          </span>
        </p>
        <p *ngIf="transfer.executionDate" class="qvs-validate-payment-order-request-proceed__description__date">
          {{ transfer.executionDate | localDate }}
        </p>
      </div>
    </ng-container>
  </qvs-status-screen>
</div>
